import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { slugify } from '../../../utils/slugify';

// components
import { AbsoluteAnchor } from '../../../global/AbsoluteAnchor/AbsoluteAnchor';

// styles
import styles from './SbRespRefineMenuStoneCutSelectInput.scss';

export class SbRespRefineMenuStoneCutSelectInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: !!props.checked,
        };

        this.onChange = this.onChange.bind(this);
    }

    static getDerivedStateFromProps(newProps, prevState) {
        if (!!newProps.checked !== prevState.checked) {
            return {
                checked: !!newProps.checked,
            };
        }
        return null;
    }

    onChange(e) {
        const { onChange } = this.props;
        const { checked } = e && e.currentTarget;

        if (typeof checked === 'boolean') {
            this.setState({ checked });
            if (onChange) {
                onChange(checked, e);
            }
        }
    }

    render() {
        const {
            stoneCut,
            value,
            count,
            linkReference,
            linkable,
            text,
            stoneCutMap,
            isHidden,
        } = this.props;
        const { checked } = this.state;

        const containerClass = classNames(styles.container, {
            'is-hidden': isHidden,
        });
        const StoneCutIcon = stoneCutMap[stoneCut];
        const stoneCutClasses = classNames({
            [styles.checked]: checked,
        });

        return (
            <div className={containerClass}>
                <AbsoluteAnchor
                    linkReference={linkReference}
                    linkable={linkable}
                    className={styles.input}
                    dataTn={`${slugify(text)}-link`}
                    onClick={e => e.preventDefault()}
                >
                    <div onClick={e => e.stopPropagation()}>
                        <input
                            id={text}
                            name={text}
                            value={value}
                            type="checkbox"
                            checked={checked}
                            onChange={this.onChange}
                            className={styles.hiddenInput}
                        />
                        <label htmlFor={text} className={styles.label}>
                            <div className={styles.stoneCutContainer}>
                                {StoneCutIcon && <StoneCutIcon className={stoneCutClasses} />}
                            </div>
                            <div className={styles.text}>{text}</div>
                        </label>
                    </div>
                </AbsoluteAnchor>
                {count && <div className={styles.count}>{count}</div>}
            </div>
        );
    }
}

SbRespRefineMenuStoneCutSelectInput.propTypes = {
    count: PropTypes.number,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    stoneCutMap: PropTypes.object,
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    linkReference: PropTypes.string.isRequired,
    linkable: PropTypes.bool.isRequired,
    stoneCut: PropTypes.string.isRequired,
    isHidden: PropTypes.bool,
};
